import Backbone from 'backbone';
const PresentationReferenceCollection = Backbone.Collection.extend({
    urlRoot: '/api/facade_presentation_reference/',
    initialize() {},
    parse(data) {
        const that = this;

        if (data) {
            that.add(data.hasOwnProperty('data') ? data.data : data);
        }
        return this.models;
    },
    fetch(siteSlug) {
        this.url = this.urlRoot + siteSlug;

        Backbone.Collection.prototype.fetch.call(this);
    },

    getNameFromKey(key) {
        const presentationReference = this.findWhere({key});

        if (!presentationReference) {
            console.warn('No presentation found with key: ', key);

            return 'No Presentation Selected';
        }

        return presentationReference.get('name');
    },
});

export default PresentationReferenceCollection;
